import { render, staticRenderFns } from "./EditSupplierType.vue?vue&type=template&id=182384e9"
import script from "./EditSupplierType.vue?vue&type=script&lang=js"
export * from "./EditSupplierType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports